import styled from 'styled-components';

import { CheckboxTheme } from './types';

export const Box = styled.div<{
  theme: CheckboxTheme;
  checked: boolean;
}>`
  border-radius: ${({ theme }) => theme.borderRadius};
  width: ${({ theme }) => theme.size};
  height: ${({ theme }) => theme.size};
  border: ${({ checked, theme }) =>
    checked ? 'none' : `1px solid ${theme.borderColor}`};
  box-sizing: border-box;
  cursor: pointer;
  background: ${({ checked, theme }) =>
    checked ? theme.checkedColor : theme.defaultColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CheckIconWrapper = styled.div``;
